const $ = require('jquery');
$.noConflict();
$.DataTable = require('datatables.net');
import WithSystem from './../service/WithSystem';
export default class LeanerTbl extends React.Component {
  constructor(props) {
    super(props);
    this.tablerender = null;
  }
  componentDidMount() {
    this.leanerTestreportrender();
  }
  leanerTestreportrender = () => {
    window.learneridTemp = this.props.learnerid;
    let setToken = (__msAuthToken)?`?ms_auth_token=${__msAuthToken}`:``;
    this.tablerender = $(this.refs.main).DataTable({
      lengthMenu: [window.showlimit],
      lengthChange: false,
      bFilter: false,
      stateSave: false,
      scrollX: true,
      ordering: true,
      columnDefs: [
      ],
      order: [[0, 'asc']],
      processing: true,
      serverSide: true,
      ajax: {
        type: 'POST',
        data: {
          learnerid: this.props.learnerid,
          learnerCourseid: this.props.leanerDropdown,
        },
        beforeSend: function () {
          $('#progress-filter-loading').addClass('show');
        },
        url: admin_url + 'Archive_consolidate_report/learners_singele_report'+setToken,
        dataSrc: function (response) {
          $('#progress-filter-loading').removeClass('show');
          $('#leanerName').html(response.learnerDetails.csa_cs_user_name);
          $('#leanerEmail').html(response.learnerDetails.csa_cs_user_email);
          $('#learnerProfileImage').html(
            `<img src="${response.learnerDetails.user_image}">`
          );
          $('#coursePrice').html(
            response.learnerDetails.csa_cs_course_currency +
              response.learnerDetails.csa_cs_course_price
          );
          $('#courseStatus').html(response.learnerDetails.csa_cs_approved);

          var subscribedCourses = response.learnerDetails.subscribed_courses;
          var courseDropdown = '';
          var learnerDetailUrl = $(location).attr('href').split('/');
          var CurrentCourseId = learnerDetailUrl[learnerDetailUrl.length - 1];
          subscribedCourses.forEach((course) => {
            if (course.csa_cs_course_id == CurrentCourseId) {
              $('#setActiveCourseName').html(course.csa_cs_course_tittle);
            }
            courseDropdown += `<li onclick="window.leanerDropdown('${course.csa_cs_course_id}')" >${course.csa_cs_course_tittle}</li>`;

          });

          $('#leanerDropdown').html(courseDropdown);
          $('#leanerBranch').html(
            response.learnerDetails.csa_us_institute_code
          );

          var csPercentage = response.learnerDetails.csa_cs_percentage;
          var percentageColour = '#ff6466';
          if (csPercentage <= 20) {
            percentageColour = '#ff6466';
          } else if (csPercentage >= 21 && csPercentage <= 40) {
            percentageColour = '#ff929E';
          } else if (csPercentage >= 41 && csPercentage <= 60) {
            percentageColour = '#fcde88';
          } else if (csPercentage >= 61 && csPercentage <= 80) {
            percentageColour = '#61dea9';
          } else if (csPercentage >= 81 && csPercentage <= 100) {
            percentageColour = '#4ebe6d';
          }
          $('#leanerProgress').html(
            response.learnerDetails.csa_cs_percentage != null
              ? `<div class="leaner-progress-bar"><div class="leaner-progress-percent" percent="${csPercentage}%" 
            style="background-color: ${percentageColour}; width: ${csPercentage}%;"></div></div><span>${csPercentage}%</span>`
              : `-`
          );
          $('#leanerEnrollment').html(
            response.learnerDetails.csa_cs_subscription_date != null
              ? changeDatesFormat(
                  convertUTCtoLocalTime(
                    response.learnerDetails.csa_cs_subscription_date
                  ),
                  'dateOnly'
                )
              : '-'
          );

          if (
            response.learnerDetails.csa_cs_completion_registered == '1' ||
            response.learnerDetails.csa_cs_percentage == '100'
          ) {
            var learnerCompletionDate = '-';
            if (
              response.learnerDetails.csa_cs_course_complete_date != null &&
              response.learnerDetails.csa_cs_course_complete_date !=
                '0000-00-00 00:00:00'
            ) {
              learnerCompletionDate = changeDatesFormat(
                convertUTCtoLocalTime(
                  response.learnerDetails.csa_cs_course_complete_date
                ),
                'dateOnly'
              );
            } else if (
              response.learnerDetails.csa_cs_percentage_updated_date != null &&
              response.learnerDetails.csa_cs_percentage_updated_date !=
                '0000-00-00 00:00:00'
            ) {
              learnerCompletionDate = changeDatesFormat(
                convertUTCtoLocalTime(
                  response.learnerDetails.csa_cs_percentage_updated_date
                ),
                'dateOnly'
              );
            }
            $('#leanerCompletion').html(learnerCompletionDate);
          } else {
            $('#leanerCompletion').html('-');
          }
          $('#leanerTimespent').html(
            typeof response.learnerDetails.csa_cs_total_duration != null
              ? secondsToHms(response.learnerDetails.csa_cs_total_duration) + ' hrs'
              : '-'
          );
          $('#leanerGrade').html(
            response.learnerDetails.csa_cs_manual_grade != null
              ? response.learnerDetails.csa_cs_manual_grade
              : response.learnerDetails.csa_cs_auto_grade
          );
          $('#leanerScore').html(
            typeof response.learnerDetails.csa_cs_marks_obtained != null
              ? response.learnerDetails.csa_cs_marks_obtained
              : '-'
          );

          var certificateIssued = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path id="Icon_ionic-md-close-circle" data-name="Icon ionic-md-close-circle" d="M9.312,1.313a8,8,0,1,0,8,8A7.972,7.972,0,0,0,9.312,1.313Zm4,10.88-1.12,1.12-2.88-2.88-2.88,2.88-1.12-1.12,2.88-2.88-2.88-2.88,1.12-1.12,2.88,2.88,2.88-2.88,1.12,1.12-2.88,2.88Z" transform="translate(-1.313 -1.313)" fill="#ff6466"></path>
          </svg>`;
          if (response.learnerDetails.csa_cs_download_certificate == '1') {
            certificateIssued = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path id="Icon_ionic-md-checkmark-circle" data-name="Icon ionic-md-checkmark-circle" d="M9.313,1.313a8,8,0,1,0,8,8A8.024,8.024,0,0,0,9.313,1.313ZM7.67,13.578l-4.1-4.1,1.15-1.15,2.954,2.954,6.235-6.235,1.15,1.15Z" transform="translate(-1.313 -1.313)" fill="#4ebe6d"></path>
          </svg>`;
          }
          $('#leanerCertificatereleased').html(certificateIssued);
          $('#leaneruuid').html(response.learnerDetails.csa_us_uuid);
          $('#leanerLastVistedDate').html(
            response.learnerDetails.csa_cs_updated_date != null
              ? changeDatesFormat(
                  convertUTCtoLocalTime(response.learnerDetails.csa_cs_updated_date),
                  'dateOnly'
                )
              : '-'
          );
          return response.aaData;
        },
      },
      columns: [
        {
          mRender: function (data, type, row) {
              return `${row.aa_lecture_id}`;
          },
        },
        {
          mRender: function (data, type, row) {
            if (row.aa_valuated == 1) {
              return `<span class="leaner-grade grade-success">Graded</span>`;
            } else {
              return `<span class="leaner-grade grade-no-success">Not Graded</span>`;
            }
          },
        },
        {
          mRender: function (data, type, row) {
            var formateed_date = formatAMPM(
              changeDatesFormat(convertUTCtoLocalTime(row.aa_attempted_date))
            );
            return `${formateed_date}`;
          },
        },
        {
          mRender: function (data, type, row) {
            return `${row.aa_attempts_views}`;
          },
        },
        {
          mRender: function (data, type, row) {
            return `${row.aa_mark_scored}`;
          },
        },
        {
          mRender: function (data, type, row) {
            return `${row.aa_grade}`;
          },
        },
      ],
      language: {
        emptyTable: innernoMsg,
      },
      drawCallback: function (settings) {},
    });
  };
  componentDidUpdate(prevProps) {
    if (this.props.leanerDropdown != prevProps.leanerDropdown) {
      $('#myTable').DataTable().destroy();
      this.leanerTestreportrender();
    }
  }

  componentWillUnmount() {
    $('.data-table-wrapper').find('table').DataTable().destroy(true);
  }
  render() {
    return (
      <div>
        <table className="display" width="100%" id="myTable" ref="main">
          <thead>
            <tr>
              <th className="no-sort">Test Name</th>
              <th className="no-sort">Status</th>
              <th className="no-sort">Completion Date</th>
              <th className="no-sort">No. of Attempts </th>
              <th className="no-sort">Marks</th>
              <th className="no-sort">Grade</th>
            </tr>
          </thead>
        </table>
      </div>
    );
  }
}
